import { render, staticRenderFns } from "./TranslatableDetails.vue?vue&type=template&id=7d72093e&"
import script from "./TranslatableDetails.vue?vue&type=script&lang=ts&"
export * from "./TranslatableDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports